import type { TopicAttributes, TopicFollowAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import TopicQ from './TopicQ'
import UserQ from './UserQ'

const TopicFollowQ = {
  ...makeQueryModelV2<TopicFollowAttributes>('topic_follow')([
    'id',
    'user_id',
    'topic_id',
    'created_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    Topic: { query: TopicQ, foreignKey: TopicQ.id, sourceKey: TopicFollowQ.topic_id },
    User: { query: UserQ, foreignKey: UserQ.id, sourceKey: TopicFollowQ.user_id },
  }),

  where: (
    {
      id,
      userId,
      topicId,
      paranoid = true,
      include = [],
      groupBy = null,
      order = null,
    }: {
      id?: number | SQLFragment<number> | null
      userId?: number | SQLFragment<number> | null
      topicId?: number | SQLFragment<number> | null
      paranoid?: boolean
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<TopicFollowAttributes> => SQL`
        FROM ${TopicFollowQ}
        ${includeAssociationsToSql(TopicFollowQ, include)}
        WHERE
            ${id != null ? SQL`${TopicFollowQ.id} = ${id} AND` : SQL``}
            ${userId != null ? SQL`${TopicFollowQ.user_id} = ${userId} AND` : SQL``}
            ${topicId != null ? SQL`${TopicFollowQ.topic_id} = ${topicId} AND` : SQL``}
            ${paranoid ? SQL`${TopicFollowQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        `,

  getFollowingTopics: (userId: number): SQLFragment<TopicAttributes> =>
    TopicFollowQ.where({
      userId,
      include: [
        {
          association: 'Topic',
          required: true,
        },
      ],
    }),
}

export default TopicFollowQ
